import "./ClientLogos.css";
import { useLang } from "../../utils/i18n";
import theWhizkindLogo from "../../../assets/logos/thewhizkind.png";
import dbVisualLogo from "../../../assets/logos/logo_quadrado_2026.png";
import regalLogo from "../../../assets/logos/rcm_loggo_light-blue-crown.png";
import reinventLogo from "../../../assets/logos/cropped-cropped-Sem-nome-167-x-61-px-1.png";
import unisistemasLogo from "../../../assets/logos/unisistemas logo vetor.png";
import ciaDeIdeiasLogo from "../../../assets/logos/WhatsApp Image 2026-05-12 at 17.39.13.jpeg";
import escolaResultadosLogo from "../../../assets/logos/WhatsApp Image 2026-05-28 at 09.38.31.jpeg";
import tessaLogo from "../../../assets/logos/tessa.jpeg";

const CLIENT_LOGOS = [
  { name: "DB Visual", src: dbVisualLogo, scale: 0.94 },
  { name: "Regal Credit Management", src: regalLogo, scale: 1.38 },
  { name: "Reinvent Consultoria & RH", src: reinventLogo, scale: 1.12 },
  { name: "Unisistemas", src: unisistemasLogo, scale: 1.48 },
  { name: "CIA de Ideias", src: ciaDeIdeiasLogo, scale: 1.55 },
  { name: "Escola de Resultados & Negócios", src: escolaResultadosLogo, scale: 1.12 },
  { name: "Tessa", src: tessaLogo, scale: 1 },
  { name: "The Whizkind", src: theWhizkindLogo, scale: 0.82 },
];

const COPY = {
  en: {
    kicker: "Selected clients & partners",
    title: "Organisations we work with",
  },
  pt: {
    kicker: "Clientes e parceiros selecionados",
    title: "Organizações com as quais trabalhamos",
  },
};

const ClientLogos = () => {
  const lang = useLang();
  const copy = COPY[lang];

  return (
    <section
      className="client-logos"
      aria-label={copy.kicker}
    >
      <header className="client-logos-header">
        <p className="client-logos-kicker">{copy.kicker}</p>
        <h2 className="client-logos-title">{copy.title}</h2>
      </header>
      <div className="client-logos-marquee">
        <ul className="client-logos-list">
          {[...CLIENT_LOGOS, ...CLIENT_LOGOS].map((client, index) => (
            <li
              className="client-logo"
              key={`${client.name}-${index}`}
              aria-hidden={index >= CLIENT_LOGOS.length}
              style={{ "--logo-scale": client.scale }}
            >
              <img
                src={client.src}
                alt={client.name}
                className="client-logo-image"
                loading="lazy"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ClientLogos;
